import { Link } from "react-router-dom";
import { BRAND } from "../lib/content";
import { useState } from "react";
import { subscribeNewsletter } from "../lib/api";
import { toast } from "sonner";

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await subscribeNewsletter(email);
      toast.success("Subscribed. Partnership updates will arrive in your inbox.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 grid grid-cols-2 md:grid-cols-12 gap-10">
        <div className="col-span-2 md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logoIcon}
              alt={BRAND.company}
              className="h-12 w-auto object-contain"
            />
            <div>
              <div className="font-display font-black text-sm tracking-tight">
                {BRAND.company.toUpperCase()}
              </div>
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#FF3B30]">
                {BRAND.brandTagline}
              </div>
            </div>
          </div>
          <h3 className="font-display font-black text-3xl md:text-4xl tracking-tighter mt-8 leading-[0.95]">
            Every partnership begins with a briefing.
          </h3>
          <p className="mt-4 text-white/60 max-w-sm leading-relaxed">
            Subscribe for technology updates and partner program announcements. No
            marketing fluff.
          </p>
          <form
            onSubmit={onSubmit}
            className="mt-6 flex w-full max-w-md border border-white/15"
            data-testid="newsletter-form"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="flex-1 bg-transparent px-4 py-3 font-mono-tech text-sm text-white placeholder:text-white/30 focus:outline-none"
              data-testid="newsletter-email"
            />
            <button
              type="submit"
              disabled={busy}
              className="px-5 py-3 bg-white text-black font-mono-tech uppercase tracking-widest text-[11px] hover:bg-white/90 disabled:opacity-50"
              data-testid="newsletter-submit"
            >
              {busy ? "…" : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="col-span-1 md:col-span-2 md:col-start-8">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
            Navigate
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/technology" className="u-link text-white/80 hover:text-white">Technology</Link></li>
            <li><Link to="/applications" className="u-link text-white/80 hover:text-white">Applications</Link></li>
            <li><Link to="/team" className="u-link text-white/80 hover:text-white">Team</Link></li>
            <li><Link to="/partners" className="u-link text-white/80 hover:text-white">Partners</Link></li>
            <li><Link to="/news" className="u-link text-white/80 hover:text-white">News</Link></li>
            <li><Link to="/careers" className="u-link text-white/80 hover:text-white">Careers</Link></li>
          </ul>
        </div>

        <div className="col-span-1 md:col-span-3">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
            Contact
          </div>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li>{BRAND.address}</li>
            <li>
              <a href={`tel:${BRAND.phone}`} className="u-link">{BRAND.phone}</a>
            </li>
            <li>
              <a href={`mailto:${BRAND.contactEmail}`} className="u-link break-all">
                {BRAND.contactEmail}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono-tech text-[11px] uppercase tracking-widest text-white/40">
          <span>© {new Date().getFullYear()} {BRAND.company} — All rights reserved</span>
          <span className="flex items-center gap-2">
            <span className="inline-block h-2 w-2 bg-[#FF3B30]" />
            Operational / Dana Point · California
          </span>
        </div>
      </div>
    </footer>
  );
}
